import { connectWithHammock, ENDPOINTS } from 'hammock';

// make sure Collection Metadata is loaded in hammock
export const CollectionMetadataLoader = connectWithHammock(({ collectionId }) => ({
  endpoint: ENDPOINTS.collections,
  id: collectionId,
}))(() => null);
